module.exports = __webpack_public_path__ + "static/media/error-404-m.4abe4aae.svg";